import React from "react";

// Yanthra Labs pyramid mark with "Y" negative space.
export function PyramidMark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="ylpyr" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#29abe2" />
          <stop offset="55%" stopColor="#1b4a9c" />
          <stop offset="100%" stopColor="#0f2557" />
        </linearGradient>
      </defs>
      <path d="M24 3 L45 44 H3 Z" fill="url(#ylpyr)" />
      <path d="M24 16 L24 30 M24 30 L18 38 M24 30 L30 38 M18 20 L24 26 L30 20"
        stroke="#f2f6fb" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.95" />
    </svg>
  );
}

export function Logo({ compact = false, onLight = false, size = 32 }) {
  const navy = onLight ? "text-[#0f2557]" : "text-white";
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="yl-logo">
      <PyramidMark size={size} />
      {!compact && (
        <div className="leading-none">
          <div className={`font-bold text-lg tracking-tight ${navy}`}>
            Yanthra<span className="text-[#29abe2]"> Labs</span>
          </div>
          <div className="text-[8px] font-semibold tracking-[0.25em] text-[#c9a227] mt-0.5">
            SMARTER SOLUTIONS FOR SMARTER WORLD
          </div>
        </div>
      )}
    </div>
  );
}
